import { render, staticRenderFns } from "./company-work-location.vue?vue&type=template&id=6b34eda6&scoped=true"
import script from "./company-work-location.vue?vue&type=script&lang=js"
export * from "./company-work-location.vue?vue&type=script&lang=js"
import style0 from "./company-work-location.vue?vue&type=style&index=0&id=6b34eda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b34eda6",
  null
  
)

export default component.exports